module.exports = __webpack_public_path__ + "img/jabaotao_hero_card.d800d9ec.png";